import { Box, Text, Flex } from '@wegroup/design-system';
import React from 'react';
import { useFlowsSelector } from '../../../../../../../common/src/utils/globalVariables';
import DuplicateObjectTag from './DuplicateObjectTag';
import Avatar from '../../../../../../../sales-conversation/src/components/default/ProdFacAvatar';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import useCurrentGroup from '../../../../../hooks/useCurrentGroup';
import { parseStringForAnswers } from '../../../../../utils/stringUtils';

interface Props {
  question: string;
  description?: string;
  horizontal?: boolean;
  index?: number;
}

const QuestionGroupAssistantQuestionContent: React.FC<
  React.PropsWithChildren<Props>
> = ({ question, description, horizontal, index }) => {
  const { position } = useFlowsRouteParams();
  const currentGroup = useCurrentGroup();

  return (
    <>
      <Box flexShrink={0} display={{ base: 'none', laptop: 'block' }}>
        <Avatar className="QuestionGroupAssistantQuestion_avatar" />
      </Box>
      <Box>
        {currentGroup && position != null && (
          <QuestionTag horizontal={horizontal} />
        )}
        <GroupAssistantText
          question={question}
          description={description}
          horizontal={horizontal}
          index={index}
        />
      </Box>
    </>
  );
};

interface GroupAssistantTextProps {
  horizontal?: boolean;
  question: string;
  description?: string;
  index?: number;
}

const GroupAssistantText: React.FC<
  React.PropsWithChildren<GroupAssistantTextProps>
> = ({ question, description, horizontal, index }) => {
  const answers = useFlowsSelector((state) => state.flows.answers);

  return (
    <div>
      <Text
        textStyle="h3Headline"
        textAlign={{ tablet: horizontal ? 'start' : 'center' }}
        data-test-id="Flows_QuestionGroupAssistantQuestion_Question"
        mb="2"
      >
        {parseStringForAnswers({ answers, question, index })}
      </Text>
      {description && (
        <Text
          color="gray.500"
          textStyle={{ base: 'normalBody', tablet: 'largeBody' }}
          textAlign={{ tablet: horizontal ? 'left' : 'center' }}
          data-test-id="Flows_QuestionGroupAssistantQuestion_Description"
          dangerouslySetInnerHTML={{
            __html: parseStringForAnswers({
              answers,
              question: description,
              index,
            }),
          }}
        />
      )}
    </div>
  );
};

interface QuestionTagProps {
  horizontal?: boolean;
}

const QuestionTag: React.FC<React.PropsWithChildren<QuestionTagProps>> = ({
  horizontal,
}) => {
  const currentGroup = useCurrentGroup();

  return (
    <Flex
      justifyContent={{ tablet: horizontal ? 'flex-start' : 'center' }}
      mt={{ base: '0', laptop: '4' }}
      mb={{ base: '3', laptop: horizontal ? '1' : '3' }}
    >
      <DuplicateObjectTag group={currentGroup} />
    </Flex>
  );
};

export default QuestionGroupAssistantQuestionContent;
